module.exports = __webpack_public_path__ + "static/media/400061_01.6e42018d.png";